<template>
  <el-popover
    placement="top"
    width="350"
    trigger="hover"
    popper-class="ap-info-popover"
  >
    <div>
      <h4 style="margin-top: 0; margin-bottom: 10px; font-weight: bold;">Artigos Perigosos</h4>
      <p style="margin-bottom: 10px; font-size: 13px;">Exemplos de artigos considerados perigosos:</p>
      <ol style="margin: 0; padding-left: 20px; font-size: 12px; line-height: 1.6;">
        <li>Perfumes e produtos com álcool</li>
        <li>Baterias de lítio</li>
        <li>Aerosóis (desodorantes, sprays)</li>
        <li>Produtos inflamáveis</li>
        <li>Tintas e solventes</li>
        <li>Produtos químicos</li>
        <li>Fósforos e isqueiros</li>
        <li>Medicamentos controlados</li>
        <li>Produtos corrosivos</li>
        <li>Materiais radioativos</li>
      </ol>
    </div>
    <i
      slot="reference"
      class="el-icon-warning-outline"
      style="color: #E6A23C; cursor: pointer; margin-left: 5px; font-size: 16px;"
    ></i>
  </el-popover>
</template>

<script>
export default {
  name: "ArtigosPerigososPopover",
};
</script>
